export default "__VITE_ASSET__tdNvzpfa__"